module.exports = __webpack_public_path__ + "static/media/location.b5ecbb1a.png";